import React from 'react';
import BlogPost from '../../../components/BlogPost';

const sections = [
  {
    title: 'Access Control',
    bullets: [
      'Establish Centralized Infrastructure Access (User Directory, SSO);',
      'Implement Role-Based / Permission-based Access Control;',
      'Leverage Principle of Least Privilege when establishing and authorizing access;',
    ],
  },
  {
    title: 'Administrative Tasks',
    bullets: [
      'Block Unused Services, Resources, Regions;',
      'Deny Public Access to Everything (Network, Hosts, Workloads, Storage, Databases), Allow by Exception;',
      'Create and Manage a Set of Encryption Keys;',
    ],
  },
  {
    title: 'Data Encryption',
    bullets: [
      'Encrypt Data at All Levels (Storage, Databases) – "At-Rest encryption";',
      'Encrypt Data Transmission with SSL/TLS Certificates – "In-Transit encryption";',
    ],
  },
  {
    title: 'Data Confidentiality',
    bullets: [
      'Organize Secret Storage for all API Keys, Tokens, Passwords, etc ("Application Secrets");',
      'Ensure Data Record Confidentiality (no PII/PHI in database records, application and service logs);',
    ],
  },
  {
    title: 'Data Backup and Recovery',
    bullets: [
      'Establish Data Classification and Data Retention Policies;',
      'Establish Data Backup and Recovery Procedures;',
    ],
  },
  {
    title: 'Vulnerability Management System ("VMS")',
    bullets: [
      'Scan container images, applications, hosts for Vulnerabilities;',
      'Perform Regular Host and Container Security Patching and Version Upgrades;',
    ],
  },
  {
    title: 'Observability',
    bullets: [
      'Implement Centralized Logging (from cloud services and applications);',
      'Configure Alerts on Critical and High Impact VMS Events;',
    ],
  },
  {
    title: 'Data Cleanliness and Integrity',
    bullets: [
      'Implement Antivirus Scanning on container images, Hosts, Cloud Storage, User-generated content;',
      'Implement Data Integrity Monitoring (files and data records);',
      'Establish monitoring of Data Exfiltration and Data Tampering;',
    ],
  },
  {
    title: 'Network Security',
    bullets: [
      'Implement Network Isolation of System Components (VLAN/VPC);',
      'Activate and Configure Network Firewall;',
      'Maximize Placement of Cloud Resources in Private Subnets;',
      'Restrict Access to Network Ports via Security Groups, NACL;',
      'Prohibit Remote Access from Broad Range Networks;',
      'Implement WAF and DDoS Protection on Web and Network Endpoints;',
    ],
  },
  {
    title: 'Maintenance Mode and Failover Protection',
    bullets: [
      'Implement System Maintenance Mode Switch;',
      'Failover Protection: Set up Backup Environment and Implement Automatic Failover Switch.',
    ],
  },
];

const WhatIsCloudSecurityPosture = () => {
  return (
    <BlogPost
      breadcrumbItems={[
        { path: '/', label: 'Home' },
        { path: '/blog', label: 'Blog' },
        { path: '/blog/cloud-security-series', label: 'Cloud Security Series' },
        {
          path: '/blog/cloud-security-series/what-is-a-cloud-security-posture',
          label: 'What is a Cloud Security Posture?',
        },
      ]}
      title="What is a Cloud Security Posture?"
      date="May 27, 2024"
      content={
        <>
          <section className="blog-post__section">
            <h2>What is a Cloud Security Posture?</h2>
            <p>
              Wonder what's goes in <strong>Cloud Infrastructure Security</strong>? Years of
              experience helped me to put together this, quite comprehensive, list.
            </p>
          </section>
          <section className="blog-post__section">
            {sections.map((section, idx) => (
              <div className="blog-post__numbered-section" key={section.title}>
                <div className="blog-post__number-title-row">
                  <span className="blog-post__number">{idx + 1}.</span>
                  <span className="blog-post__list-title">{section.title}</span>
                </div>
                <ul>
                  {section.bullets.map(bullet => (
                    <li key={bullet}>{bullet}</li>
                  ))}
                </ul>
              </div>
            ))}
          </section>
          <section className="blog-post__section">
            <p>
              See anything missing? 🕵‍♂️
              <br />
              How would you prioritize these items, and why? 🤔
            </p>
          </section>
        </>
      }
      cta={{
        title: 'We Are Here to Help!',
        text: "Struggling to set up or simplify your SOC 2 compliance? Our expert team at DevSecOps, Inc. specializes in making compliance manageable and straightforward for lean startups. We've successfully helped numerous startups quickly and affordably achieve compliance without sacrificing agility.",
        buttonText: `Let's Talk`,
        buttonHref: '/contact-us',
      }}
      nextPost={{
        href: '/blog/cloud-security-series/access-control',
        label: 'Next: Access Control',
      }}
    />
  );
};

export default WhatIsCloudSecurityPosture;
